import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { postData } from '../../Api';
import {
    MobileInfoBox,
    Modal,
    PanelBox,
    TextView,
    Title
} from '../../components/Display';
import {
    Button,
    DataForm,
    MultiSelectBox,
    SearchBox,
    SearchDateBox,
} from '../../components/Form';
import {
    Components,
    Grid,
    GridColumn,
    LeftComponents,
    RightComponents,
    Row,
} from '../../components/Layout';
import {
    TableBody,
    TableColumn,
    TableData,
    TableHeader,
    TableRow,
} from '../../components/Table';
import TaroffOrdersEdit from '../orders/TaroffOrdersEdit';
import TaroffOrdersView from '../orders/TaroffOrdersView';
import TaroffOrdersPeikSetNotAccepted from '../peik/TaroffOrdersPeikSetNotAccepted';
import TaroffOrdersSetPeik from '../peik/TaroffOrdersSetPeik';

export default function TaroffOrdersPeikReady(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const handlecomp1 = () => {
        console.log('data-select-');
    };
    const handlecomp3 = () => {
        console.log('handlecomp3');
    };
    const handlecomp2 = () => {
        const childDialog = (
            <>
                <DataForm>
                    <Grid>
                        <GridColumn width={12}>
                            <Title>انتساب دسته ای سفارشات به پیک</Title>
                        </GridColumn>
                    </Grid>
                    <Grid>
                        <GridColumn width={12}>
                            <TextView>آیا انتساب همه ی سفارشات انتخاب شده به «</TextView>
                            {/* <TextView>{formViewTextTitle}</TextView> */}
                            <TextView>» مورد تایید است؟</TextView>
                        </GridColumn>
                    </Grid>
                    <Grid>
                        <GridColumn width={12}>
                            <Button onClick={handlecomp3}>ذخیره و ارسال شده</Button>
                        </GridColumn>
                    </Grid>
                </DataForm>
            </>
        );
        setModal(
            Modal({
                children: childDialog,
                onDismiss: () => setModal(null),
            })
        );
        console.log('child-dialog');
    };
    const handlecomp5 = () => {
        console.log('handlecomp5');
    };
    const handlecomp4 = () => {
        const childDialog = (
            <>
                <Button onClick={handlecomp5} color={'secondary'} rightIcon={'far fa-print'}>
                    پرینت
                </Button>
                <RightComponents wrap={true}>
                    <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                        جستجو
                    </Button>
                    <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                        پاک کردن
                    </Button>
                </RightComponents>
                <TableData
                    total={tableData.total}
                    size={tableSize}
                    page={tablePage}
                    setPage={gotoPage}
                >
                    <TableHeader>
                        <TableRow>
                            <TableColumn mobile={true}>mobile</TableColumn>
                            <TableColumn mobile={false}>عنوان</TableColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {tableData.rows?.map((row, index) => (
                            <TableRow key={index}>
                                <TableColumn mobile={true}>
                                    <MobileInfoBox />
                                </TableColumn>
                                <TableColumn mobile={false}>
                                    <Row>
                                        <RightComponents>
                                            <TextView>{row.text}</TextView>
                                            <TextView>{row.text_id}</TextView>
                                        </RightComponents>
                                        <Components>
                                            <TextView>{row.text_2}</TextView>
                                        </Components>
                                    </Row>
                                    <RightComponents>
                                        <TextView>{row.text_shop_id_title}</TextView>
                                        <TextView>{row.text_3}</TextView>
                                        <TextView>{row.text_shop_id_mobile}</TextView>
                                        <TextView>{row.text_4}</TextView>
                                        <TextView>{row.text_shop_id_phone}</TextView>
                                    </RightComponents>
                                    <RightComponents>
                                        <TextView bold={true}>{row.text_title_2}</TextView>
                                        <TextView>{row.text_5}</TextView>
                                        <TextView format={'money'}>
                                            {row.text_payable_price}
                                        </TextView>
                                        <TextView>{row.text_6}</TextView>
                                    </RightComponents>
                                    <TextView>{row.text_address}</TextView>
                                    <RightComponents>
                                        <TextView bold={true}>{row.text_customer_name}</TextView>
                                        <TextView>{row.text_7}</TextView>
                                        <TextView bold={true}>{row.text_customer_phone}</TextView>
                                    </RightComponents>
                                    <TextView>{row.text_note}</TextView>
                                </TableColumn>
                            </TableRow>
                        ))}
                    </TableBody>
                </TableData>
            </>
        );
        setModal(
            Modal({
                children: childDialog,
                onDismiss: () => setModal(null),
            })
        );
        console.log('child-dialog');
    };
    const [formQShopIdOptions, setFormQShopIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik-ready/select-data/q-shop-id').then(
            (response) => {
                setFormQShopIdOptions(response.data);
            }
        );
    }, []);
    const [formQZoneIdOptions, setFormQZoneIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik-ready/select-data/q-zone-id').then(
            (response) => {
                setFormQZoneIdOptions(response.data);
            }
        );
    }, []);
    const [formQShiftIdOptions, setFormQShiftIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik-ready/select-data/q-shift-id').then(
            (response) => {
                setFormQShiftIdOptions(response.data);
            }
        );
    }, []);
    const [formQDeliverTimeIdOptions, setFormQDeliverTimeIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik-ready/select-data/q-deliver-time-id').then(
            (response) => {
                setFormQDeliverTimeIdOptions(response.data);
            }
        );
    }, []);
    const handlecomp6 = () => {
        applyFilters();
    };
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setFilterQId('');
        setFilterQShopId('');
        setFilterQZoneId('');
        setFilterQTitle('');
        setFilterQInsertTimeFrom('');
        setFilterQInsertTimeTo('');
        setFilterQShiftId('');
        setFilterQDeliverTimeId('');
        setFilterQCustomerName('');
        setFilterQAddress('');
        setFilterQPostCode('');
        setFilterQCustomerMobile('');
        setFilterQShopCodeIn('');
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        filterQId && (newSearchParams['q-id'] = filterQId);
        filterQShopId && (newSearchParams['q-shop-id'] = filterQShopId);
        filterQZoneId && (newSearchParams['q-zone-id'] = filterQZoneId);
        filterQTitle && (newSearchParams['q-title'] = filterQTitle);
        filterQInsertTimeFrom && (newSearchParams['q-insert-time-from'] = filterQInsertTimeFrom);
        filterQInsertTimeTo && (newSearchParams['q-insert-time-to'] = filterQInsertTimeTo);
        filterQShiftId && (newSearchParams['q-shift-id'] = filterQShiftId);
        filterQDeliverTimeId && (newSearchParams['q-deliver-time-id'] = filterQDeliverTimeId);
        filterQCustomerName && (newSearchParams['q-customer-name'] = filterQCustomerName);
        filterQAddress && (newSearchParams['q-address'] = filterQAddress);
        filterQPostCode && (newSearchParams['q-post-code'] = filterQPostCode);
        filterQCustomerMobile && (newSearchParams['q-customer-mobile'] = filterQCustomerMobile);
        filterQShopCodeIn && (newSearchParams['q-shop-code-in'] = filterQShopCodeIn);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [filterQId, setFilterQId] = useState(allProps['q-id'] || '');
    const [filterQShopId, setFilterQShopId] = useState(allProps['q-shop-id'] || '');
    const [filterQZoneId, setFilterQZoneId] = useState(allProps['q-zone-id'] || '');
    const [filterQTitle, setFilterQTitle] = useState(allProps['q-title'] || '');
    const [filterQInsertTimeFrom, setFilterQInsertTimeFrom] = useState(
        allProps['q-insert-time-from'] || ''
    );
    const [filterQInsertTimeTo, setFilterQInsertTimeTo] = useState(
        allProps['q-insert-time-to'] || ''
    );
    const [filterQShiftId, setFilterQShiftId] = useState(allProps['q-shift-id'] || '');
    const [filterQDeliverTimeId, setFilterQDeliverTimeId] = useState(
        allProps['q-deliver-time-id'] || ''
    );
    const [filterQCustomerName, setFilterQCustomerName] = useState(
        allProps['q-customer-name'] || ''
    );
    const [filterQAddress, setFilterQAddress] = useState(allProps['q-address'] || '');
    const [filterQPostCode, setFilterQPostCode] = useState(allProps['q-post-code'] || '');
    const [filterQCustomerMobile, setFilterQCustomerMobile] = useState(
        allProps['q-customer-mobile'] || ''
    );
    const [filterQShopCodeIn, setFilterQShopCodeIn] = useState(allProps['q-shop-code-in'] || '');
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik-ready/table-data', {
            size: tableSize,
            page: tablePage,
            q_id: filterQId,
            q_shop_id: filterQShopId,
            q_zone_id: filterQZoneId,
            q_title: filterQTitle,
            q_insert_time_from: filterQInsertTimeFrom,
            q_insert_time_to: filterQInsertTimeTo,
            q_shift_id: filterQShiftId,
            q_deliver_time_id: filterQDeliverTimeId,
            q_customer_name: filterQCustomerName,
            q_address: filterQAddress,
            q_post_code: filterQPostCode,
            q_customer_mobile: filterQCustomerMobile,
            q_shop_code_in: filterQShopCodeIn,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    const handlecomp7 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersSetPeik
                        taroff-order-id={row.param_id}
                        taroff-peik-id={row.param_id_2}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp8 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersEdit
                        taroff-orders-id={row.param_id_3}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp9 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersView
                        taroff-orders-id={row.param_id_4}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp10 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersPeikSetNotAccepted
                        taroff-orders-id={row.param_id_5}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    return (
        <PanelBox>
            <Row>
                <RightComponents>
                    <Title>سفارشات آماده ارسال</Title>
                </RightComponents>
                <LeftComponents>
                    <TextView></TextView>
                    <TextView></TextView>
                    <Button onClick={handlecomp1} color={'secondary'}>
                        انتخاب پیک
                    </Button>
                    <Button
                        onClick={handlecomp2}
                        color={'secondary'}
                        rightIcon={'far fa-check-double'}
                    >
                        انتساب دسته ای به پیک
                    </Button>
                    <Button onClick={handlecomp4} color={'secondary'} rightIcon={'far fa-print'}>
                        لیست آماده ارسال
                    </Button>
                </LeftComponents>
            </Row>
            <SearchBox onEnter={applyFilters} label={'شناسه'} value={filterQId} onChange={setFilterQId} width={'120px'} />
            <MultiSelectBox
                label={'فروشگاه'}
                options={formQShopIdOptions}
                value={filterQShopId}
                onChange={setFilterQShopId}
            />
            <MultiSelectBox
                label={'محدوده'}
                options={formQZoneIdOptions}
                value={filterQZoneId}
                onChange={setFilterQZoneId}
            />
            <SearchBox onEnter={applyFilters}
                label={'عنوان'}
                value={filterQTitle}
                onChange={setFilterQTitle}
                width={'120px'}
            />
            <SearchDateBox onEnter={applyFilters}
                label={'زمان درج از'}
                value={filterQInsertTimeFrom}
                onChange={setFilterQInsertTimeFrom}
                width={'100px'}
            />
            <SearchDateBox onEnter={applyFilters}
                label={'زمان درج تا'}
                value={filterQInsertTimeTo}
                onChange={setFilterQInsertTimeTo}
                width={'100px'}
            />
            <MultiSelectBox
                label={'شیفت های پیک تعارف'}
                options={formQShiftIdOptions}
                value={filterQShiftId}
                onChange={setFilterQShiftId}
            />
            <MultiSelectBox
                label={'زمان ارسال'}
                options={formQDeliverTimeIdOptions}
                value={filterQDeliverTimeId}
                onChange={setFilterQDeliverTimeId}
            />
            <SearchBox onEnter={applyFilters}
                label={'نام خریدار'}
                value={filterQCustomerName}
                onChange={setFilterQCustomerName}
                width={'120px'}
            />
            <SearchBox onEnter={applyFilters}
                label={'آدرس'}
                value={filterQAddress}
                onChange={setFilterQAddress}
                width={'120px'}
            />
            <SearchBox onEnter={applyFilters}
                label={'کد پستی'}
                value={filterQPostCode}
                onChange={setFilterQPostCode}
                width={'120px'}
            />
            <SearchBox onEnter={applyFilters}
                label={'همراه خریدار'}
                value={filterQCustomerMobile}
                onChange={setFilterQCustomerMobile}
                width={'120px'}
            />
            <Button onClick={handlecomp6} color={'secondary'}>
                جستجو
            </Button>
            <SearchBox onEnter={applyFilters}Chips
                label={'کد رهگیری در فروشگاه'}
                value={filterQShopCodeIn}
                onChange={setFilterQShopCodeIn}
            />
            <RightComponents wrap={true}>
                <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                    جستجو
                </Button>
                <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                    پاک کردن
                </Button>
            </RightComponents>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>ردیف</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>آدرس سفارش</TableColumn>
                        <TableColumn mobile={false}>عنوان محدوده سفارش</TableColumn>
                        <TableColumn mobile={false}>عنوان پیک سفارش</TableColumn>
                        <TableColumn mobile={false}>مبلغ سفارش</TableColumn>
                        <TableColumn mobile={false}>زمان درج سفارش</TableColumn>
                        <TableColumn mobile={false}> </TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id_2}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_shop_id_title_2}</TextView>
                                <RightComponents>
                                    <TextView>{row.text_title_3}</TextView>
                                    <TextView>{row.text_8}</TextView>
                                    <TextView>{row.text_shop_code}</TextView>
                                </RightComponents>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_address_2}</TextView>
                                <RightComponents>
                                    <TextView>{row.text_customer_name_2}</TextView>
                                    <TextView>{row.text_customer_mobile}</TextView>
                                </RightComponents>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_zone_id_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_peik_id_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'money'}>{row.text_payable_price_2}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'persian-date-normal'}>
                                    {row.text_insert_time}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <LeftComponents>
                                    {row.show && (
                                        <Button
                                            onClick={() => handlecomp7(row)}
                                            color={'accent'}
                                            rightIcon={'far fa-check'}
                                            tooltip={'انتساب به پیک'}
                                        ></Button>
                                    )}
                                    <Button
                                        onClick={() => handlecomp8(row)}
                                        color={'accent'}
                                        rightIcon={'far fa-edit'}
                                        tooltip={'ویرایش'}
                                    ></Button>
                                    <Button
                                        onClick={() => handlecomp9(row)}
                                        rightIcon={'far fa-info'}
                                        tooltip={'Taroff Orders View'}
                                    ></Button>
                                    <Button
                                        onClick={() => handlecomp10(row)}
                                        color={'warn'}
                                        rightIcon={'fal fa-times'}
                                        tooltip={'عدم قبول پیک'}
                                    ></Button>
                                </LeftComponents>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
